import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";

export default function FlexibleDisplaysUseCase() {
  return (
    <>
    <section
      id="flexible-displays"
      className="min-h-screen pt-[96px] pb-20 px-6 sm:px-8 bg-[#1A1631] text-white scroll-mt-[96px]"
    >
      <div className="max-w-5xl mx-auto space-y-10">

        {/* Back Link */}
        <Link
          to="/"
          className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
        >
          ← Back to main site
        </Link>

        {/* Heading + Intro */}
        <div className="space-y-4">
          <h1 className="sm:text-2xl font-bold bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">
            Flexible Displays
          </h1>
          <p className="text-slate-300 space-y-2">
            Flexible displays are revolutionising consumer electronics by enabling foldable phones, rollable tablets, curved TVs, and wearable screens.
            Unlike traditional rigid displays, flexible displays are built on bendable substrates (such as plastic or ultrathin glass) and use organic or hybrid materials to maintain performance under mechanical stress.

            <br /><br />

            These displays integrate multiple organic electronic components, including OLEDs for light emission, OTFTs for switching, and flexible encapsulation layers for environmental protection.
            Critical materials must combine excellent optoelectronic performance with mechanical flexibility, thermal stability, and long-term durability.
            The interplay between electronic properties and structural behaviour under bending, folding, or stretching requires careful molecular design and materials matching.

            <br /><br />

            Flexible displays are not just a form factor innovation — they demand a new materials discovery paradigm across emitters, charge transport layers, electrodes, and encapsulants.
          </p>
        </div>

        {/* How Apoello Helps */}
<div className="space-y-4">
  <h2 className="text-2xl font-semibold text-orange-300">How DiaDEM™ helps</h2>
  <ul className="list-disc list-inside text-slate-300 space-y-2">
    <li>
      Discover stable, high-emission molecules with precomputed excited-state energies, oscillator strengths, and air sensitivity filters.
    </li>
    <li>
      Explore candidate emitters with strong oscillator strengths and complementary absorption profiles.
    </li>
    <li>
      Predict solid-state packing and charge mobility for assessing performance in flexible device architectures.
    </li>
    <li>
      Order shortlisted materials directly via integrated procurement.
    </li>
  </ul>
</div>

        {/* Why It Matters */}
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold text-orange-300">Why It Matters</h2>
          <p className="text-slate-300 max-w-3xl">
            Flexible electronics demand materials that go beyond traditional performance metrics.
            DiaDEM™ allows researchers to explore electronic and mechanical properties in tandem — helping you discover materials that don’t just work on paper, but survive in the real world of bending and stress.
            This shortens development timelines and reduces costly trial-and-error synthesis.
          </p>
        </div>

        {/* CTA Button */}
        <div className="pt-8">
          <Link
            to="/diadem-overview"
            className="inline-block px-6 py-3 bg-[#EF7C34] text-white rounded-xl font-medium hover:bg-[#F89B3F] transition"
          >
            Explore the DiaDEM™ Platform →
          </Link>
        </div>

      </div>
    </section>
          {/* ✅ Minimal Footer always sits outside main content */}
      <Footer />
    </>
  );
}
